import { removeWishlistItemBySKU } from "lib/api"
import type { ItemType, VisualRefType, WishListUpdateResultType } from "types"
import { siteUrl } from "utils/getSiteUrl"

export const onRemoveUserWish = async (
  item: ItemType
): Promise<boolean | WishListUpdateResultType> => {
  if (!item.variant) return false

  return removeWishlistItemBySKU(item.variant.sku)
}

export const getMembershipVisualUrl = (visual?: VisualRefType): string => {
  if (!visual) return ""

  // Commercetools membership images are served from the CT CDN
  if (visual.url.startsWith("https://")) {
    return visual.url
  }

  const host = process.env.NODE_ENV === "test" ? "" : siteUrl
  return `${host}${visual.url}`
}
